import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaDocumentosAprovados = (): TabelaColuna => ({
  Chave: 'documentosAprovados',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 100 }}>Doc. Aprovados</div>
})
